var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "aee80b81-4e70-4cb3-b038-b1155adc452e",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "vbl") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M95.77,60.17a12.41,12.41,0,1,0-12.4-12.41A12.4,12.4,0,0,0,95.77,60.17Zm0-21.93a9.53,9.53,0,1,1-9.52,9.52A9.54,9.54,0,0,1,95.77,38.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3,60.2A12.41,12.41,0,1,0,18.89,47.8,12.4,12.4,0,0,0,31.3,60.2Zm0-21.93a9.53,9.53,0,1,1-9.53,9.53A9.53,9.53,0,0,1,31.3,38.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,64.71A14.64,14.64,0,1,0,49.39,50.07,14.64,14.64,0,0,0,64,64.71Zm0-26.28A11.64,11.64,0,1,1,52.39,50.07,11.66,11.66,0,0,1,64,38.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.51,61.32,96.24,70.6,87,61.32a25.8,25.8,0,0,0-9.17,6,32.5,32.5,0,0,0-3.24-1.47L64,76.38,53.48,65.85a28.59,28.59,0,0,0-3.28,1.49,25.83,25.83,0,0,0-9.15-6l-9.29,9.28-9.27-9.28A26,26,0,0,0,9.54,72.17V85H38.79v7.69H89.24V84.92h29.22V72.14A26,26,0,0,0,105.51,61.32ZM38.79,82.13H12.45l.05-9s.48-.83.74-1.21a23.1,23.1,0,0,1,8.82-7.29l7.87,7.86,1.83,1.83,9.69-9.69a22.93,22.93,0,0,1,6.16,4.24,29.67,29.67,0,0,0-8.82,9.23Zm25.26,7.5H41.65l0-4.69V82.13l0-2.89s.54-1,.86-1.39a27.06,27.06,0,0,1,7.08-6.71c.84-.54,1.71-1,2.59-1.48l.55-.26,9.1,9.11L64,80.62l2.12-2.11,9.11-9.11.5.25a25.76,25.76,0,0,1,2.61,1.48,26.86,26.86,0,0,1,7.1,6.72c.31.43.85,1.39.85,1.39l0,2.86v2.82l0,4.72ZM89.24,82.1v-4a29.64,29.64,0,0,0-8.86-9.25,22.67,22.67,0,0,1,6.17-4.26l9.69,9.69h0l1.83-1.82,7.86-7.87a23.05,23.05,0,0,1,8.82,7.3c.27.37.74,1.2.74,1.2l.06,9Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.dd66b46889ad937f28e54f8a5b4e5c70.svg";
export { ForwardRef as ReactComponent };